import { PcsConversationFetchedEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { findStlTaskForCall } from './findStlTaskForCall';

/**
 * Handles phone.pcs.conversation.fetched for STL tasks.
 * Stores PCS conversation sid as a task attribute.
 * The STL task ID is NOT updated — it keeps the API taskId throughout its lifecycle.
 */
function handleStlPcsConversationFetched(ev: PcsConversationFetchedEvent) {
  const { remoteIdentity, direction } = ev.phoneStateUpdateEvent.callState;
  if (direction !== 'originating') return;

  const stlTask = findStlTaskForCall(remoteIdentity);
  if (!stlTask) return;

  const { sid: pcsConversationSid } = ev.pcsConversation;

  TasksModule.setTaskAttribute(
    stlTask.id,
    'pcsConversationSid',
    pcsConversationSid,
  );
}

export default handleStlPcsConversationFetched;
